export default "__VITE_ASSET__CCMK7uon__"